<div class="container-fluid p-4">
  <h3 class="title mb-3">Mis propiedades</h3>
  @if (buildingList().length > 0) {
    <div class="row mb-3">
      <div class="col-12 col-md-6 col-lg-4">
        <p-iconfield>
          <p-inputicon class="pi pi-search" />
          <input
            pInputText
            type="search"
            [ngModel]="searchQuery()"
            (ngModelChange)="searchQuery.set($event)"
            placeholder="Buscar por dirección, localidad o suministro..."
            class="w-100"
            aria-label="Buscar propiedades"
          />
        </p-iconfield>
      </div>
    </div>
  }
  <div class="row g-3">
    @for (building of filteredBuildingList(); track building.tenantId) {
      <div class="col-12 col-md-6 col-lg-4 col-xl-3">
        <div
          class="building-card h-100 p-4 border rounded-3 position-relative cursor-pointer transition-all"
          [class.selected-border]="selectedBuilding?.tenantId === building.tenantId"
          (click)="selectBuilding(building)"
        >
          <div class="d-flex align-items-start mb-2">
            <i
              class="pi pi-building me-3 fs-3"
              [class.t-primary]="selectedBuilding?.tenantId === building.tenantId"
            ></i>
            <div class="flex-grow-1">
              <h6
                class="building-address mb-1 fw-bold"
                [class.building-address--sm]="building.tenantAddress.length > 50"
                [class.building-address--xs]="building.tenantAddress.length > 80"
                [class.t-primary]="selectedBuilding?.tenantId === building.tenantId"
              >
                {{ building.tenantAddress }}
              </h6>
              <small class="text-muted d-block">{{ building.tenantCity }}</small>
            </div>
            @if (selectedBuilding?.tenantId === building.tenantId) {
              <i class="pi pi-check-circle t-primary fs-5 ms-2"></i>
            }
          </div>

          <div class="d-flex flex-wrap gap-2 mt-3">
            @for (supply of building.suppliers; track supply.id) {
              <span class="supply-badge" [ngStyle]="getSupplyStyle(supply.id)">
                <!-- <i [class]="getSupplyIcon(supply.id)" class="me-1"></i> -->
                <i-lucide [name]="getSupplyIcon(supply.id)" class="me-1 icon" size="20"></i-lucide>
                {{ supply.name }}
              </span>
            }
          </div>
        </div>
      </div>
    } @empty {
      @if (!isLoading()) {
        <div class="col-12 text-center py-5">
          @if (buildingList().length === 0) {
            <p class="text-muted">No hay propiedades disponibles</p>
          } @else if (searchQuery()) {
            <p class="text-muted">No se encontraron propiedades para «{{ searchQuery() }}»</p>
          }
        </div>
      }
    }

    @if (buildingList().length > 0) {
      <div class="col-12 col-md-6 col-lg-4 col-xl-3">
        <div
          class="add-property-card h-100 d-flex align-items-center p-4 border rounded-3 cursor-pointer"
          (click)="openAddBuilding()"
        >
          <i class="pi pi-plus text-muted me-3 fs-4"></i>
          <span class="flex-grow-1 fw-semibold text-muted">Añadir propiedad</span>
        </div>
      </div>
    }
  </div>
</div>
